import React from "react";
import Modal from "../../../components/ui/Modal";
import { Calendar, Plus, Loader2 } from "lucide-react";

interface EventForm {
  title: string;
  description: string;
  startDate: string;
  endDate: string;
  isAllDay: boolean;
}

interface Props {
  isOpen: boolean;
  title: string;
  form: EventForm;
  loading: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
  submitLabel: string;
}

export default function EventFormModal({ isOpen, title, form, loading, onChange, onSubmit, onCancel, submitLabel }: Props) {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} title={title} size="md">
      <form onSubmit={onSubmit} className="space-y-5">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Etkinlik Başlığı <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={onChange}
            placeholder="Örn: Takım Toplantısı"
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Açıklama <span className="text-red-500">*</span>
          </label>
          <textarea
            name="description"
            value={form.description}
            onChange={onChange}
            rows={3}
            placeholder="Etkinlik hakkında detaylı bilgi..."
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all resize-none"
            required
          />
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
          <label className="flex items-center space-x-3 cursor-pointer">
            <input
              type="checkbox"
              name="isAllDay"
              checked={form.isAllDay}
              onChange={onChange}
              className="w-4 h-4 rounded text-blue-600 focus:ring-2 focus:ring-blue-500"
            />
            <div className="flex items-center gap-2">
              <Calendar className="w-4 h-4 text-blue-600" />
              <span className="text-sm font-medium text-gray-700">Tüm Gün Sürecek</span>
            </div>
          </label>
        </div>

        {!form.isAllDay && (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Başlangıç <span className="text-red-500">*</span>
              </label>
              <input
                type="datetime-local"
                name="startDate"
                value={form.startDate}
                onChange={onChange}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Bitiş <span className="text-red-500">*</span>
              </label>
              <input
                type="datetime-local"
                name="endDate"
                value={form.endDate}
                onChange={onChange}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                required
              />
            </div>
          </div>
        )}

        <div className="flex gap-3 pt-3 border-t border-gray-200">
          <button
            type="submit"
            disabled={loading}
            className="flex-1 inline-flex items-center justify-center gap-2 bg-green-600 text-white px-5 py-2.5 rounded-lg text-sm font-semibold hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm hover:shadow">
            {loading ? (
              <>
                <Loader2 className="animate-spin h-4 w-4" />
                Kaydediliyor...
              </>
            ) : (
              <>
                <Plus className="w-4 h-4" />
                {submitLabel}
              </>
            )}
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="flex-1 bg-white px-5 py-2.5 rounded-lg border border-gray-300 text-sm font-semibold text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            İptal
          </button>
        </div>
      </form>
    </Modal>
  );
}
